"use strict";

angular.module("core").service("loaderGoogleMapAPI", function() {
    var googleScript;
    var languageSet;

    this.loadScript = function(language, callbackFunc) {
        language = (language) ? language : "en";

        if (languageSet != language) {
            if (googleScript) {
                window.google = null; // JS Global variable deinitialise to give google signal to initialise it back again
                document.getElementsByTagName("head")[0].removeChild(googleScript)
            }

            languageSet = language;
            googleScript = document.createElement("script");
            googleScript.type = "text/javascript";
            //googleScript.async = true; // do not use
            googleScript.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyAs7mG3KEtj5PU8hGf4Zx_JjjD-7FO0PPo"
                + "&libraries=places&language=" + language;

            document.getElementsByTagName("head")[0].appendChild(googleScript);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/loader-google-map-api/loader-google-map-api.service.js
// module id = 421
// module chunks = 0